import { Fragment } from 'react/jsx-runtime';
import { ContractNavigationEnum } from 'v3/data/store/contractCard/enum';
import { ContractingStateEnum } from 'v3/data/store/contracting/enums';
import { WarningCard } from 'v3/shared/components/WarningCard';
import { theme } from 'v3/styles/global-styles';

export const getInfoSnackbar = (contractingState: ContractingStateEnum, contractStep: ContractNavigationEnum) => {
  const ContractStepsWithSnackBar = [
    ContractNavigationEnum.INITIAL,
    ContractNavigationEnum.PRE_CONTRACT,
    ContractNavigationEnum.DEVICE_DETAILS,
    ContractNavigationEnum.SIGN_CONTRACT,
  ];

  const snackbarProperties = {
    [ContractingStateEnum.WaitingTermsAcceptance]: {
      message: 'Pronto! Você pode enviar o token para o cliente',
      backgroundColor: theme.palette.green.main,
    },
    [ContractingStateEnum.ProcessingAntiFraud]: {
      message:
        'Atualize a página ou clique no status para atualizar. Aguarde o status mudar  ”Aguardando Efetivação do Contrato” para concluir o processo',
      backgroundColor: theme.palette.warning.main,
    },
    [ContractingStateEnum.WaitingContractEffectiveness]: {
      message: contractStep.includes(ContractNavigationEnum.PRE_CONTRACT)
        ? 'Pronto! Você pode baixar o pre-contrato'
        : 'Pronto! Informe os dados da compra e assine o contrato',
      backgroundColor: theme.palette.green.main,
    },
  };
  let currentMessage = snackbarProperties[contractingState];

  if (!currentMessage) {
    currentMessage = {
      message: 'Aguarde o status mudar para "Aguardando Aceite dos Termos" para enviar o token',
      backgroundColor: theme.palette.warning.main,
    };
  }

  return ContractStepsWithSnackBar.includes(contractStep) ? (
    <WarningCard message={currentMessage.message} backgroundColor={currentMessage.backgroundColor} />
  ) : (
    <Fragment />
  );
};
